import { InvoicePaymentStatusEnum } from "@/__generated__/graphql";
import { Badge } from "@/components/ui";
import { isBefore, subDays } from "date-fns";
import { useMemo } from "react";

export function PaymentStatusBadge({
  amount,
  balance,
  dueDate,
  status,
}: {
  amount: number;
  balance: number;
  dueDate: Date;
  status: InvoicePaymentStatusEnum;
}) {
  const { tagLabel, tagVariant } = useMemo(() => {
    const isUnpaid = [
      InvoicePaymentStatusEnum.Unpaid,
      InvoicePaymentStatusEnum.Underpaid,
    ].includes(status);

    if (status === InvoicePaymentStatusEnum.Paid) {
      return { tagVariant: "success", tagLabel: "Paid" } as const;
    }

    if (status === InvoicePaymentStatusEnum.StripeProcessing) {
      return { tagVariant: "info", tagLabel: "Processing" } as const;
    }
    if (isUnpaid) {
      const dueTag =
        balance < amount
          ? "Underpaid"
          : isBefore(dueDate, subDays(new Date(), 1))
            ? "Overdue"
            : "Due";
      return { tagVariant: "danger", tagLabel: dueTag } as const;
    }

    return { tagVariant: "success", tagLabel: status } as const;
  }, [status, amount, balance, dueDate]);

  return <Badge variant={tagVariant}>{tagLabel}</Badge>;
}
